import authAxios from "../utility/authAxios";
import { API_VERSION, REPORT_SERVICE_PATH } from "../config/axios";
import { setHttpParams } from "../utility/utils";
import { getLocalUserInfo } from "../utility/authHelper";
import { ROLE_TYPES } from "../utility/constants";

const API_URI = `${API_VERSION}/${REPORT_SERVICE_PATH}/reports`;

const prepareRequest = (type, params, additional) => {
    const { role_type, company_id, counter_id, id } = getLocalUserInfo();
    params = setHttpParams(params);
    if (
        [
            ROLE_TYPES.SUPER_ADMIN,
            ROLE_TYPES.GDS_ADMIN,
            ROLE_TYPES.GDS_CALL_CENTRE_AGENT,
        ].includes(role_type)
    ) {
        if (type == "dashboard_todays_sales_history") {
            return authAxios.post(`${API_URI}/1/show?${params}`, additional);
        } else if (type == "dashboard_todays_cancelled_history") {
            return authAxios.post(`${API_URI}/4/show?${params}`, additional);
        } else if (type == "dashboard_todays_online_sales_history") {
            return authAxios.post(`${API_URI}/7/show?${params}`, additional);
        } else if (type == "dashboard_todays_online_cancellation_history") {
            return authAxios.post(`${API_URI}/9/show?${params}`, additional);
        } else if (type == "gds_coach_wise_sales") {
            return authAxios.post(`${API_URI}/11/show?${params}`, additional);
        } else if (type == "dashboard_saas_sales_summary") {
            return authAxios.post(`${API_URI}/12/show?${params}`, additional);
        } else if (type == "dashboard_gds_sales_summary") {
            return authAxios.post(`${API_URI}/16/show?${params}`, additional);
        } else if (type == "gds_coach_wise_sales_recent_downloads") {
            return authAxios.get(`${API_URI}/recent-download/11`, {
                headers: {
                    "x-requester-id": id,
                },
            });
        } else if (type == "gds_coach_wise_sales_download_request") {
            return authAxios.post(
                `${API_URI}/11/download?${params}`,
                {},
                {
                    headers: {
                        "x-requester-id": id,
                    },
                }
            );
        }
    } else if (
        company_id &&
        counter_id &&
        [ROLE_TYPES.COMPANY_COUNTER].includes(role_type)
    ) {
        if (type == "dashboard_todays_sales_history") {
            return authAxios.post(`${API_URI}/2/show?${params}`, {
                counter_id,
                book_by: id,
            });
        } else if (type == "dashboard_todays_cancelled_history") {
            return authAxios.post(`${API_URI}/5/show?${params}`, {
                counter_id,
                book_by: id,
            });
        } else if (type == "dashboard_saas_sales_summary") {
            return authAxios.post(`${API_URI}/15/show?${params}`, {
                counter_id,
                book_by: id,
            });
        }
    } else if (
        company_id &&
        [
            ROLE_TYPES.COMPANY_ADMIN,
            ROLE_TYPES.COMPANY_CALL_CENTRE_MANAGER,
        ].includes(role_type)
    ) {
        if (type == "dashboard_todays_sales_history") {
            return authAxios.post(`${API_URI}/3/show?${params}`, {
                company_id,
            });
        } else if (type == "dashboard_todays_cancelled_history") {
            return authAxios.post(`${API_URI}/6/show?${params}`, {
                company_id,
            });
        } else if (type == "dashboard_todays_online_sales_history") {
            return authAxios.post(`${API_URI}/8/show?${params}`, {
                company_id,
            });
        } else if (type == "dashboard_todays_online_cancellation_history") {
            return authAxios.post(`${API_URI}/10/show?${params}`, {
                company_id,
            });
        } else if (type == "dashboard_saas_sales_summary") {
            return authAxios.post(`${API_URI}/13/show?${params}`, {
                company_id,
            });
        } else if (type == "dashboard_gds_sales_summary") {
            return authAxios.post(`${API_URI}/17/show?${params}`, {
                company_id,
            });
        }
    }

    ////// Process Each Page ////////
    if (type == "user_wise_sales_counter") {
        return authAxios.post(`${API_URI}/18/show?${params}`, additional);
    } else if (type == "counter_user_wise_sales_recent_downloads") {
        return authAxios.get(`${API_URI}/recent-download/18`, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "counter_user_wise_sales_download_request") {
        return authAxios.post(`${API_URI}/18/download?${params}`, additional, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "counter_wise_sales_journey_date") {
        return authAxios.post(`${API_URI}/19/show?${params}`, additional);
    } else if (type == "counter_wise_sales_purchase_date") {
        return authAxios.post(`${API_URI}/20/show?${params}`, additional);
    } else if (type == "counter_wise_sales_journey_date_download_request") {
        return authAxios.post(`${API_URI}/19/download?${params}`, additional, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "counter_wise_sales_purchase_date_download_request") {
        return authAxios.post(`${API_URI}/20/download?${params}`, additional, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "counter_wise_sales_journey_date_recent_downloads") {
        return authAxios.get(`${API_URI}/recent-download/19`, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "counter_wise_sales_purchase_date_recent_downloads") {
        return authAxios.get(`${API_URI}/recent-download/20`, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "user_wise_sales_summary") {
        return authAxios.post(`${API_URI}/21/show?${params}`, additional);
    } else if (type == "user_wise_sales_summary_recent_downloads") {
        return authAxios.get(`${API_URI}/recent-download/21`, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "user_wise_sales_summary_download_request") {
        return authAxios.post(`${API_URI}/21/download?${params}`, additional, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "new_counter_wise_sales") {
        return authAxios.post(`${API_URI}/22/show?${params}`, additional);
    } else if (type == "new_counter_wise_sales_download_request") {
        return authAxios.post(`${API_URI}/22/download?${params}`, additional, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "new_counter_wise_sales_recent_downloads") {
        return authAxios.get(`${API_URI}/recent-download/22`, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "old_user_sales_counter") {
        return authAxios.post(`${API_URI}/23/show?${params}`, additional);
    } else if (type == "old_user_sales_counter_download_request") {
        return authAxios.post(`${API_URI}/23/download?${params}`, additional, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "old_user_sales_counter_recent_downloads") {
        return authAxios.get(`${API_URI}/recent-download/23`, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "leaving_coach_report") {
        return authAxios.post(`${API_URI}/24/show?${params}`, additional);
    } else if (type == "leaving_coach_report_download_request") {
        return authAxios.post(`${API_URI}/24/download?${params}`, additional, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "leaving_coach_report_recent_downloads") {
        return authAxios.get(`${API_URI}/recent-download/24`, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "counter_coach_wise_sales") {
        return authAxios.post(`${API_URI}/25/show?${params}`, additional);
    } else if (type == "counter_coach_wise_sales_download_request") {
        return authAxios.post(`${API_URI}/25/download?${params}`, additional, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "counter_coach_wise_sales_recent_downloads") {
        return authAxios.get(`${API_URI}/recent-download/25`, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "counter_ticket_wise_sales") {
        return authAxios.post(`${API_URI}/26/show?${params}`, additional);
    } else if (type == "counter_ticket_wise_sales_download_request") {
        return authAxios.post(`${API_URI}/26/download?${params}`, additional, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "counter_ticket_wise_sales_recent_downloads") {
        return authAxios.get(`${API_URI}/recent-download/26`, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "counter_prepaid_balance_report") {
        return authAxios.post(`${API_URI}/48/show?${params}`, additional);
    } else if (type == "counter_prepaid_balance_report_download_request") {
        return authAxios.post(`${API_URI}/48/download?${params}`, additional, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "counter_prepaid_balance_report_recent_downloads") {
        return authAxios.get(`${API_URI}/recent-download/48`, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "dwh_transaction_daily") {
        return authAxios.post(`${API_URI}/28/show?${params}`, additional);
    } else if (type == "dwh_transaction_daily_download_request") {
        return authAxios.post(`${API_URI}/28/download?${params}`, additional, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "dwh_transaction_daily_recent_downloads") {
        return authAxios.get(`${API_URI}/recent-download/28`, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "dwh_users") {
        return authAxios.post(`${API_URI}/29/show?${params}`, additional);
    } else if (type == "dwh_users_download_request") {
        return authAxios.post(`${API_URI}/29/download?${params}`, additional, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "dwh_users_recent_downloads") {
        return authAxios.get(`${API_URI}/recent-download/29`, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "company_wise_sales") {
        return authAxios.post(`${API_URI}/30/show?${params}`, additional);
    } else if (type == "company_wise_sales_download_request") {
        return authAxios.post(`${API_URI}/30/download?${params}`, additional, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "company_wise_sales_recent_downloads") {
        return authAxios.get(`${API_URI}/recent-download/30`, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "daily_bus_report_bdtickets") {
        return authAxios.post(`${API_URI}/31/show?${params}`, additional);
    } else if (type == "daily_bus_report_bdtickets_download_request") {
        return authAxios.post(`${API_URI}/31/download?${params}`, additional, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "daily_bus_report_bdtickets_recent_downloads") {
        return authAxios.get(`${API_URI}/recent-download/31`, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "zone_wise_sales_counter") {
        return authAxios.post(`${API_URI}/32/show?${params}`, additional);
    } else if (type == "zone_wise_sales_counter_download_request") {
        return authAxios.post(`${API_URI}/32/download?${params}`, additional, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "zone_wise_sales_counter_recent_downloads") {
        return authAxios.get(`${API_URI}/recent-download/32`, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "zone_wise_sales_summary_counter_recent_downloads") {
        return authAxios.get(`${API_URI}/recent-download/47`, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "prepaid_counter_sales") {
        return authAxios.post(`${API_URI}/33/show?${params}`, additional);
    } else if (type == "prepaid_counter_sales_download_request") {
        return authAxios.post(`${API_URI}/33/download?${params}`, additional, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "prepaid_counter_sales_recent_downloads") {
        return authAxios.get(`${API_URI}/recent-download/33`, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "day_wise_sales") {
        return authAxios.post(`${API_URI}/34/show?${params}`, additional);
    } else if (type == "day_wise_sales_download_request") {
        return authAxios.post(`${API_URI}/34/download?${params}`, additional, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "day_wise_sales_recent_downloads") {
        return authAxios.get(`${API_URI}/recent-download/34`, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "day_wise_sales_summary") {
        return authAxios.post(`${API_URI}/35/show?${params}`, additional);
    } else if (type == "day_wise_sales_summary_download_request") {
        return authAxios.post(`${API_URI}/35/download?${params}`, additional, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "day_wise_sales_summary_recent_downloads") {
        return authAxios.get(`${API_URI}/recent-download/35`, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "daily_air_report_bdtickets") {
        return authAxios.post(`${API_URI}/37/show?${params}`, additional);
    } else if (type == "daily_air_report_bdtickets_download_request") {
        return authAxios.post(`${API_URI}/37/download?${params}`, additional, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "daily_air_report_bdtickets_recent_downloads") {
        return authAxios.get(`${API_URI}/recent-download/37`, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "route_wise_sales_report") {
        return authAxios.post(`${API_URI}/40/show?${params}`, additional);
    } else if (type == "route_wise_sales_report_download_request") {
        return authAxios.post(`${API_URI}/40/download?${params}`, additional, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "route_wise_sales_report_recent_downloads") {
        return authAxios.get(`${API_URI}/recent-download/40`, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "leaving_coach_report_summary") {
        return authAxios.post(`${API_URI}/39/show?${params}`, additional);
    } else if (type == "leaving_coach_report_summary_download_request") {
        return authAxios.post(`${API_URI}/39/download?${params}`, additional, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "leaving_coach_report_summary_recent_downloads") {
        return authAxios.get(`${API_URI}/recent-download/39`, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "registration_no_wise_sales") {
        return authAxios.post(`${API_URI}/38/show?${params}`, additional);
    } else if (type == "registration_no_wise_sales_download_request") {
        return authAxios.post(`${API_URI}/38/download?${params}`, additional, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "registration_no_wise_sales_recent_downloads") {
        return authAxios.get(`${API_URI}/recent-download/38`, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "counter_coach_wise_sales_booking") {
        return authAxios.post(
            `${API_URI}/trip-wise-sales-booking/show?${params}`,
            additional
        );
    } else if (type == "counter_coach_wise_sales_booking_download_request") {
        return authAxios.post(
            `${API_URI}/trip-wise-sales-booking/42/download?${params}`,
            additional,
            {
                headers: {
                    "x-requester-id": id,
                },
            }
        );
    } else if (type == "counter_coach_wise_sales_booking_recent_downloads") {
        return authAxios.get(`${API_URI}/recent-download/42`, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "route_fare_wise_sales") {
        return authAxios.post(
            `${API_URI}/route-fare-wise-sales/show?${params}`,
            additional
        );
    } else if (type == "route_fare_wise_sales_download_request") {
        return authAxios.post(
            `${API_URI}/route-fare-wise-sales/43/download?${params}`,
            additional,
            {
                headers: {
                    "x-requester-id": id,
                },
            }
        );
    } else if (type == "route_fare_wise_sales_recent_downloads") {
        return authAxios.get(`${API_URI}/recent-download/43`, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "daily_sales_statement") {
        return authAxios.post(
            `${API_URI}/daily-sales-statement/show?${params}`,
            additional
        );
    } else if (type == "daily_sales_statement_download_request") {
        return authAxios.post(
            `${API_URI}/daily-sales-statement/41/download?${params}`,
            additional,
            {
                headers: {
                    "x-requester-id": id,
                },
            }
        );
    } else if (type == "daily_sales_statement_recent_downloads") {
        return authAxios.get(`${API_URI}/recent-download/41`, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "leaving_coach_report_v2") {
        return authAxios.post(
            `${API_URI}/leaving-trip-report-v2/show?${params}`,
            additional
        );
    } else if (type == "leaving_coach_report_v2_download_request") {
        return authAxios.post(
            `${API_URI}/leaving-trip-report-v2/36/download?${params}`,
            additional,
            {
                headers: {
                    "x-requester-id": id,
                },
            }
        );
    } else if (type == "leaving_coach_report_v2_recent_downloads") {
        return authAxios.get(`${API_URI}/recent-download/36`, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "coach_wise_sales_summary") {
        return authAxios.post(
            `${API_URI}/coach-wise-sales-summary/show?${params}`,
            additional
        );
    } else if (type == "coach_wise_sales_summary_download_request") {
        return authAxios.post(
            `${API_URI}/coach-wise-sales-summary/44/download?${params}`,
            additional,
            {
                headers: {
                    "x-requester-id": id,
                },
            }
        );
    } else if (type == "coach_wise_sales_summary_recent_downloads") {
        return authAxios.get(`${API_URI}/recent-download/44`, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "all_sms_report") {
        return authAxios.post(`${API_URI}/45/show?${params}`, additional);
    } else if (type == "all_sms_report_download_request") {
        return authAxios.post(`${API_URI}/45/download?${params}`, additional, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "all_sms_report_recent_downloads") {
        return authAxios.get(`${API_URI}/recent-download/45`, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "new_all_counter_wise_sales_user_purchase_date_wise") {
        return authAxios.post(
            `${API_URI}/new-counter-wise-sales/show-user-purchase-date-wise?${params}`,
            additional
        );
    } else if (type == "leaving_trip_report_summary_route_wise") {
        return authAxios.post(
            `${API_URI}/leaving-trip-report-summary-route-wise/show?${params}`,
            additional,
            {
                headers: {
                    "x-requester-id": id,
                },
            }
        );
    } else if (
        type == "leaving_trip_report_summary_route_wise_download_request"
    ) {
        return authAxios.post(
            `${API_URI}/leaving-trip-report-summary-route-wise/download?${params}`,
            additional,
            {
                headers: {
                    "x-requester-id": id,
                },
            }
        );
    } else if (type == "leaving_trip_report_v2_route_wise") {
        return authAxios.post(
            `${API_URI}/leaving-trip-report-v2-route-wise/show?${params}`,
            additional,
            {
                headers: {
                    "x-requester-id": id,
                },
            }
        );
    } else if (type == "leaving_trip_report_v2_route_wise_download_request") {
        return authAxios.post(
            `${API_URI}/leaving-trip-report-v2/36/download-route-wise?${params}`,
            additional,
            {
                headers: {
                    "x-requester-id": id,
                },
            }
        );
    } else if (type == "all_counter_user_wise_sales") {
        return authAxios.post(`${API_URI}/46/show?${params}`, additional);
    } else if (type == "all_counter_user_wise_sales_download_request") {
        return authAxios.post(`${API_URI}/46/download?${params}`, additional, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "all_counter_user_wise_sales_recent_downloads") {
        return authAxios.get(`${API_URI}/recent-download/46`, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "leaving_trip_report_route_wise") {
        return authAxios.post(
            `${API_URI}/leaving-trip-report-route-wise/show?${params}`,
            additional,
            {
                headers: {
                    "x-requester-id": id,
                },
            }
        );
    } else if (type == "leaving_coach_report_route_wise_download_request") {
        return authAxios.post(
            `${API_URI}/leaving-trip-report-route-wise/download?${params}`,
            additional,
            {
                headers: {
                    "x-requester-id": id,
                },
            }
        );
    } else if (type == "zone_wise_sales_summary") {
        return authAxios.post(`${API_URI}/47/show?${params}`, additional, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "zone_wise_sales_summary_download_request") {
        return authAxios.post(
            `${API_URI}/zone-wise-sales-summary/47/download?${params}`,
            additional,
            {
                headers: {
                    "x-requester-id": id,
                },
            }
        );
    } else if (type == "desh_india_report") {
        return authAxios.post(`${API_URI}/49/show?${params}`, additional);
    } else if (type == "desh_india_report_download_request") {
        return authAxios.post(`${API_URI}/49/download?${params}`, additional, {
            headers: {
                "x-requester-id": id,
            },
        });
    } else if (type == "desh_india_report_recent_downloads") {
        return authAxios.get(`${API_URI}/recent-download/49`, {
            headers: {
                "x-requester-id": id,
            },
        });
    }
    ////// Process Each Page END ////////
};

export const getAll = async (type, params = {}, additional = {}) => {
    const { username } = getLocalUserInfo();
    let extendsParams = { ...params, loginusername: username || "" };
    let extendsAdditional = { ...additional, loginusername: username || "" };
    return prepareRequest(type, extendsParams, extendsAdditional);
};
